import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const userId = localStorage.getItem('userid');


  if (userId) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;

